// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2iUuP","savePackageButton":"ClientWallet_savePackageButton__1XkPe"};